const carouselItems = [
  {
    id: 1,
    title: '暑期档综艺大战：谁是最终赢家？',
    source: '综艺观察',
    time: '3小时前',
    tag: '焦点专题',
    img: 'https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20multiple%20TV%20screens%20showing%20variety%20show%20scenes%20in%20a%20gallery%20wall%20layout%2C%20entertainment%20competition%20theme%2C%20coral%20amber%20warm%20palette%2C%20modern%20editorial%20design%2C%20no%20text%20no%20letters%2C%20premium%20magazine%20style&width=1200&height=675&seq=car-01-2026&orientation=landscape',
  },
  {
    id: 2,
    title: '网红经济下半场：流量红利消退后的生存法则',
    source: '行业深读',
    time: '5小时前',
    tag: '深度分析',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20illustration%20of%20a%20declining%20graph%20chart%20with%20social%20media%20icons%20floating%20around%2C%20business%20analysis%20theme%2C%20coral%20amber%20warm%20colors%2C%20modern%20editorial%20design%2C%20no%20text%20no%20letters&width=1200&height=675&seq=car-02-2026&orientation=landscape',
  },
  {
    id: 3,
    title: '2024上半年娱乐圈大事记：这些瓜你吃过几个？',
    source: '年度回顾',
    time: '7小时前',
    tag: '特别策划',
    img: 'https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20a%20timeline%20with%20highlighted%20milestone%20markers%20on%20a%20warm%20gradient%20background%2C%20year%20review%20theme%2C%20coral%20amber%20palette%2C%20modern%20editorial%20design%2C%20no%20text%20no%20letters&width=1200&height=675&seq=car-03-2026&orientation=landscape',
  },
  {
    id: 4,
    title: '从素人到顶流：草根网红的崛起之路有多难？',
    source: '人物特写',
    time: '9小时前',
    tag: '人物故事',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20illustration%20of%20a%20staircase%20leading%20upward%20toward%20a%20bright%20glowing%20star%2C%20career%20journey%20theme%2C%20coral%20amber%20warm%20colors%2C%20modern%20editorial%20design%2C%20no%20text%20no%20letters%2C%20aspirational%20vibe&width=1200&height=675&seq=car-04-2026&orientation=landscape',
  },
  {
    id: 5,
    title: '吃瓜有风险！2024年度十大反转事件盘点',
    source: '真相追踪',
    time: '11小时前',
    tag: '反转特辑',
    img: 'https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20a%20dramatic%20plot%20twist%20visual%20with%20arrow%20changing%20direction%20on%20a%20warm%20background%2C%20unexpected%20reversal%20theme%2C%20coral%20amber%20palette%2C%20modern%20editorial%20design%2C%20no%20text%20no%20letters&width=1200&height=675&seq=car-05-2026&orientation=landscape',
  },
  {
    id: 6,
    title: '娱乐圈CP文化观察：从荧幕情侣到全民磕糖',
    source: '文化观察',
    time: '13小时前',
    tag: '文化专题',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20illustration%20of%20two%20overlapping%20heart%20shapes%20with%20film%20camera%20and%20popcorn%20elements%2C%20romance%20and%20entertainment%20theme%2C%20coral%20amber%20warm%20colors%2C%20modern%20editorial%20design%2C%20no%20text%20no%20letters&width=1200&height=675&seq=car-06-2026&orientation=landscape',
  },
];

export default function Carousel() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            🎯 焦点大瓜
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            深度专题报道，全方位解读今日吃瓜事件的来龙去脉
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselItems.map((item) => (
            <a
              key={item.id}
              href="#carousel"
              className="group block rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 text-[10px] font-label font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{item.time}</span>
                </div>
                <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug mb-1">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-400 whitespace-nowrap">{item.source}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}